import React from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
    useCurrentStudyChatStatus,
    useCurrentStudyRooms,
    useCurrentStudyUsersData,
    useCurrentUserId,
} from '../state/chat-client.state';
import { getChatRoomAvatar, getChatRoomTitle } from '../utils/chat-client.utils';
import Footer from './footer';
import Header from './header';
import Timeline from './timeline';

const Content = (props) => {
    const { roomId } = props;

    const { t } = useTranslation();

    const chatStatus = useCurrentStudyChatStatus();
    const rooms = useCurrentStudyRooms();
    const currentStudyUsersData = useCurrentStudyUsersData();
    const currentUserId = useCurrentUserId();

    if (!chatStatus.isReady || !roomId || !rooms || !rooms[roomId]) {
        return null;
    }

    const currentRoom = rooms[roomId];

    return (
        <div className={clsx('flex column nowrap')}>
            <Header
                avatar={getChatRoomAvatar(currentRoom, currentStudyUsersData)}
                title={getChatRoomTitle(currentRoom, currentStudyUsersData, currentUserId, t)}
                online={currentRoom.direct ? currentStudyUsersData[currentRoom.otherMemberId]?.isOnline : undefined}
                direct={currentRoom.direct}
                roomId={roomId}
            />
            <Timeline
                {...currentRoom.timeline}
                roomId={roomId}
                key={roomId}
                otherMembersLastReadMarker={currentRoom.otherMembersLastReadMarker}
                direct={currentRoom.direct}
            />
            <Footer roomId={roomId} />
        </div>
    );
};

Content.defaultProps = {
    roomId: undefined,
};

Content.propTypes = {
    roomId: PropTypes.string,
};

export default Content;
